<template>
    <div class="panel panel-info">
        <!-- Default panel contents -->
        <div class="panel-heading">
            <i class="fa fa-barcode" aria-hidden="true"></i> NOVO BOLETO
        </div>
        <div class="panel-body">

            <div class="form-group">

                <div class="col-md-3">
                    <label class="control-label">VALOR</label>
                    <currency-input v-model="boleto.valor"></currency-input>
                </div>

                <div class="col-md-3">
                    <label class="control-label">DATA</label>
                    <dropdown class="form-group">
                        <div class="input-group">
                            <input class="form-control" disabled type="text" v-model="date">
                            <div class="input-group-btn">
                                <button class="btn btn-success" type="button" data-role="trigger">
                                    <i class="fa fa-calendar" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <template slot="dropdown">
                            <li>
                                <date-picker :today-btn="false"
                                             :clear-btn="false" :format="'dd-MM-yyyy'"
                                             v-model="date"></date-picker>
                            </li>
                        </template>
                    </dropdown>
                </div>

                <div class="col-md-3" style="margin-bottom: 0px">
                    <label class="control-label">&nbsp;</label><br/>
                    <button class="btn btn-success">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> NOVO BOLETO
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { CurrencyInput } from "../../components/exports";
export default {
    components: {
        CurrencyInput
    },
    props: ["contrato_id"],

    data() {
        return {
            boleto: {
                valor: 0,
                date: null
            },
            date: null
        };
    }
};
</script>
